export const iconFontAwesomeHumanitarianPersonCirclePlus = (
	<i className="fa-solid fa-person-circle-plus"></i>
);
